import { useEffect }    from 'react';
import { connect }      from 'react-redux';
// Redux
import {getApps}    from '../../redux/actions/Apps';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/apps';

const Index = ({stateView, token, getApps}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getApps(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='App' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getApps})(Index);
